import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, CardMedia, Input, } from '@mui/material'
import ApplyCoupon from './applycoupon';
import ViewCard from './viewCard';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function BookService({ open, onClose, setOpen }: ModalProps) {
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState(0);
    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const [openAIModal, setOpenAIModal] = useState(false);

    return (
        <><Modal
            className="modal book_service_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Book Service</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                        <div className="gap_p">


                            <div className="control_group w_100">
                                <label>Choose your requirements</label>

                                <div className="checkbox_group gap_p">
                                    <div className="check_item control_group w_25">
                                        <input type="checkbox" id="outdoor" />
                                        <label htmlFor="outdoor">Outdoor shoot</label>
                                    </div>

                                    <div className="check_item control_group w_25">
                                        <input type="checkbox" id="whiteBG" />
                                        <label htmlFor="whiteBG">White background</label>
                                    </div>

                                    <div className="check_item control_group w_25">
                                        <input type="checkbox" id="retouch" />
                                        <label htmlFor="retouch">Retouching needed</label>
                                    </div>

                                    <div className="check_item control_group w_25">
                                        <input type="checkbox" id="express24" />
                                        <label htmlFor="express24">Express delivery (24h)</label>
                                    </div>
                                </div>
                            </div>
                            <div className="control_group w_100 w_50">
                                <label htmlFor="">  Optional attachments
                                </label>

                                {image ? (
                                    <div className="upload_image">
                                        <div className="upload_image_holder">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="photo" />
                                            </figure>
                                            <CloseIcon
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }} />
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image" htmlFor="icon-button-file">
                                        <Input
                                            sx={{ display: "none" }}
                                            id="icon-button-file"
                                            type="file"
                                            inputProps={{
                                                accept: "image/png,image/jpeg",
                                            }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = (event.target as HTMLInputElement).files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                } else {
                                                    setAlertType(0);
                                                    setShowAlert(true);
                                                    setAlertMessage("This field only accepts images.");
                                                }
                                            }} />
                                        <span className="upload_image_holder square">
                                            <figure className="add_img">
                                                <img
                                                    src="/static/images/placeholder.png"
                                                    alt="icon" />
                                                <span className="upload_img_icon">
                                                    <img src="/static/images/edit2_icon.svg" alt="icon" />
                                                </span>
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>

                            {/* Additional Notes */}
                            <div className="control_group w_100">
                                <label>Additional notes (optional)</label>
                                <TextField
                                    placeholder="Additional notes"
                                    fullWidth

                                    hiddenLabel
                                    minRows={3}
                                />
                            </div>
                            <div className="control_group w_100" >
                                <label htmlFor=""> Apply Coupon</label>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <TextField
                                        placeholder="Enter Coupon Code"
                                        fullWidth
                                        hiddenLabel />
                                    <Button className="btn btn_primary" style={{ whiteSpace: "nowrap" }} onClick={() => setOpenAIModal(true)}>Apply Coupon</Button>
                                </div>
                            </div>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>Proceed to payment</Button>
                        </div>

                    </form>
                </div>
            </div>
        </Modal>
            <ApplyCoupon
                open={openAIModal}
                onClose={() => setOpenAIModal(false)}
                setOpen={setOpenAIModal} />
        </>
    )
}
